import { Component } from "react"
import PropTypes from "prop-types"
import pluralize from "pluralize"
import { debounce, trim } from "lodash"
import { Card, TextField, Grid, IconButton } from "@mui/material"
import { Search as SearchIcon, Clear } from "@mui/icons-material"

import "./style.scss"

class Search extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    search: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    current: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      query: "",
      debouncing: false,
    }
  }

  debouncedSearch = debounce((v) => { this.props.search(v); this.setState({ debouncing: false }) }, 300)

  componentDidUpdate() {
    const { query, debouncing } = this.state
    const { current } = this.props

    if (current !== query && current === "" && !debouncing) {
      this.setState({ query: "" })
    }
  }

  changeQuery = (e) => {
    this.setState(
      { query: e.target.value, debouncing: true },
      () => this.debouncedSearch(trim(this.state.query)),
    )
  }

  clearSearch = () => {
    const { clear } = this.props
    this.setState(
      { query: "" },
      () => clear(),
    )
  }

  render() {
    const { count } = this.props
    const { query } = this.state

    return (
      <Card className="search" square elevation={1}>
        <Grid
          container
          spacing={1}
          className="input"
          sx={{
          alignItems: "flex-end",
        }}
        >
          <Grid>
            <SearchIcon />
          </Grid>
          <Grid className="field">
            <TextField
              variant="standard"
              value={query}
              placeholder="Search datasets"
              onChange={this.changeQuery}
            />
          </Grid>
          {query !== ""
            && <Grid className="clear">
              <IconButton size="small" aria-label="Clear" onClick={this.clearSearch}>
                <Clear />
              </IconButton>
            </Grid>}
        </Grid>
        <div className="count">
          <span>{count}&nbsp;{pluralize("result", count)}</span>
        </div>
      </Card>
    )
  }
}

export default Search
